<ion-header>
    <ion-toolbar class="ion-padding-end">
        <!-- <ion-title *ngIf="Title" slot="start">{{Title}}</ion-title> -->
        <ion-button style="margin-right: -16px;" fill="clear" color="dark" shape="round" slot="end" (click)="Close()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>

    </ion-toolbar>

    <ion-toolbar style="display: none;">
        <ion-grid class="ion-no-padding">
            <ion-row class="ion-padding-horizontal">
                <ion-searchbar #search></ion-searchbar>
            </ion-row>
        </ion-grid>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">

    <ion-grid class="ion-no-padding">

        <ion-row class="sticky ion-margin-bottom ion-padding-bottom">

            <ion-col size="12">
                <form [formGroup]="Form">
                    <ion-grid>

                        <ion-row>
                            <ion-col class="ion-margin-end">
                                <ion-item class="full" lines="full" fill="outline">
                                    <ion-label position="stacked" i18n=":@@select_file_upload.name">Nome
                                    </ion-label>
                                    <ion-input formControlName="Name"></ion-input>

                                </ion-item>
                            </ion-col>

                            <ion-col size="12" sizeLg="4">
                                <ion-item class="full" lines="full" fill="outline">
                                    <ion-label position="stacked" i18n=":@@select_file_upload.number-process"
                                        required>Nº Processo
                                    </ion-label>
                                    <ion-input formControlName="ProcessNumber"></ion-input>

                                </ion-item>
                            </ion-col>

                        </ion-row>

                    </ion-grid>

                </form>

            </ion-col>


            <ion-col size="12">

                <ion-item class="full" lines="full" fill="outline">
                    <ion-label position="stacked" i18n=":@@select_file_upload.upload" required>Ficheiro
                    </ion-label>

                    <input-browse [fileName]="File?.OriginalName" [fileURL]="File?.Path" [accept]="FileFormatsAllowed"
                        (callback)="OnChangeFile($event)"></input-browse>

                </ion-item>
            </ion-col>

            <ion-col size="12" class="flex-center-custom ion-margin-top">

                <ion-button i18n=":@@select_file_upload.process_btn" color="medium"
                    (click)="OnGenerateLetter($event)">Cartas</ion-button>

                <ion-button i18n=":@@select_file_upload.process_btn" color="medium"
                    (click)="OnGenerateZIP($event)">Ficheiro
                    (ZIP)</ion-button>

                <ion-button class="ion-padding-start" i18n=":@@select_file_upload.process_btn"
                    (click)="OnUploadFile($event)">Guardar Pedido</ion-button>

                <ion-button disabled class="ion-padding-start" i18n=":@@select_file_upload.send_btn">Enviar
                    Pedido (mIO)</ion-button>


            </ion-col>
        </ion-row>

        <ng-container *templateVar="(Users | searchValueProperty: search.value) as Users">

            <ion-row class="ion-padding-horizontal">
                <ion-list style="width: 100%" class="ion-padding-horizontal">

                    <ion-item class="ion-no-margin" *ngFor="let item of Users; let i= index">
                        <ion-row class="full">
                            <ion-col style="max-width: 60px;">{{(i+1)}}</ion-col>
                            <ion-col>{{item?.OwnerInfo?.Name||'--'}}</ion-col>
                        </ion-row>
                    </ion-item>

                </ion-list>
            </ion-row>

            <no-items *ngIf="Users?.length==0"></no-items>

        </ng-container>

    </ion-grid>

</ion-content>